import React from "react";
import Select, { components } from "react-select";
import CreatableSelect from "react-select/creatable";
import DownArrowIcon from "../../assets/icons/down-arrow-icon";

const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <DownArrowIcon
        fill="var(--stand-alone-input-color)"
        customStyles={{
          transition: "transform 0.2s ease",
          transform: props.selectProps.menuIsOpen ? "rotate(180deg)" : "rotate(0deg)",
          width: "10px",
          height: "6px"
        }}
      />
    </components.DropdownIndicator>
  );
};

const ItemsSelectFieldStandalone = ({
  label = "Uom",
  isLabelReq,
  placeholder,
  labelClass,
  options,
  isCreatable = false,
  value,
  onChange,
  fieldClass = "w-full",
  isSearchable = true,
  isDisabled = false,
}) => {
  const SelectComponent = isCreatable ? CreatableSelect : Select;

  return (
    <div className="flex items-center gap-1 min-w-full">
      {isLabelReq && (
        <label
          style={{
            maxHeight: "32px",
            color: "var(--stand-alone-input-label-color)",
            fontSize: "var(--stand-alone-label-fs)",
            fontWeight: "var(--stand-alone-label-font-weight)",
          }}
          className={`${labelClass} text-nowrap`}
        >
          {label}
        </label>
      )}

      <div className={fieldClass}>
        <SelectComponent
          menuPortalTarget={document.body}
          value={options?.find((option) => option.value === value) || (value ? { label: value, value: value } : null)}
          options={options}
          styles={customStyles}
          components={{ DropdownIndicator }}
          onChange={(selectedOption) => {
            onChange(selectedOption);
          }}
          isSearchable={isSearchable}
          isDisabled={isDisabled}
          placeholder={placeholder}
        />
      </div>
    </div>
  );
};

const customStyles = {
  menuPortal: (base) => ({
    ...base,
    zIndex: 9999,
  }),

  indicatorSeparator: () => ({
    display: "none",
  }),

  control: (base, state) => ({
    ...base,
    width: "100%",
    height: "32px",
    minHeight: "32px",
    backgroundColor: "var(--stand-alone-input-bg)",
    color: "var(--stand-alone-input-color)",
    fontSize: "var(--stand-alone-input-font-size)",
    fontWeight: "var(--stand-alone-input-font-weight)",
    borderColor: state.isFocused
      ? "var(--stand-alone-input-focus)"
      : "var(--stand-alone-input-border)",
    boxShadow: "none",
    borderRadius: "6px",
    display: "flex",
    alignItems: "center",
    padding: "0",
    margin: "0",
    transition: "border-color 0.2s ease",
    "&:hover": {
      borderColor: "var(--stand-alone-input-focus)",
    },
    opacity: state.isDisabled ? 0.7 : 1,
  }),

  valueContainer: (base) => ({
    ...base,
    flexWrap: "nowrap",
    height: "32px",
    padding: "0 8px",
    display: "flex",
    alignItems: "center",
    lineHeight: "1",
    margin: "0",
  }),

  singleValue: (base) => ({
    ...base,
    display: "flex",
    alignItems: "center",
    color: "var(--stand-alone-input-color)",
    fontSize: "var(--stand-alone-input-font-size)",
    fontWeight: "var(--stand-alone-input-font-weight)",
    lineHeight: "1",
    margin: "0",
  }),

  placeholder: (base) => ({
    ...base,
    color: "var(--stand-alone-place-color)",
    fontFamily: "Inter, sans-serif",
    fontSize: "var(--stand-alone-place-font-size)",
    fontWeight: "var(--stand-alone-place-font-weight)",
    display: "flex",
    alignItems: "center",
    lineHeight: "1",
    margin: "0",
    opacity: "0.9",
  }),

  option: (provided, state) => ({
    ...provided,
    color: "var(--stand-alone-input-color)",
    backgroundColor: state.isSelected
      ? "#e5ecffb2"
      : state.isFocused
        ? "#0000002E"
        : "transparent",
    borderBottom: "1px solid #F5F5F5",
    fontFamily: "Inter, sans-serif",
    fontSize: "var(--stand-alone-place-font-size)",
    fontWeight: "var(--stand-alone-place-font-weight)",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#0000002E",
    },
  }),

  multiValue: (base) => ({
    ...base,
    backgroundColor: "#E5ECFF",
    gap: "5px",
    padding: "0 6px",
    display: "flex",
    alignItems: "center",
    margin: "0",
  }),

  dropdownIndicator: (provided, state) => ({
    ...provided,
    padding: "0 8px",
    display: "flex",
    alignItems: "center",
    height: "100%",
    cursor: "pointer",
    color: state.isFocused ? "var(--stand-alone-input-focus)" : "var(--stand-alone-input-color)",
  }),
};

export default ItemsSelectFieldStandalone;
